// extracted by mini-css-extract-plugin
module.exports = {"detail":"detail--1yA_z1rjW","changed":"changed--2DUbvLVRg"};